type Coords = [lon: number, lat: number];

export const isCoordsFlipped = ([lon, lat]: Coords) => {
  if (lat >= 90 || lat <= -90) return 'definitely';
  if (lon >= 90 || lon <= -90) return 'absolutely no';

  return 'not likely';
};
